import {StyleSheet, Text, View} from 'react-native'

import {IS_WEB} from '#/env'
import {atoms as a, useTheme} from '#/alf'
import {HeroSectionPage} from './HeroSectionPage'

export function Homepage() {
  const t = useTheme()

  if (IS_WEB) {
    return (
      <div className="flex flex-col w-full">
        <HeroSectionPage />
      </div>
    )
  }

  return (
    <View style={[a.flex_1, a.justify_center, a.align_center, t.atoms.bg]}>
      <Text style={[styles.placeholder, t.atoms.text]}>Batesky</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  placeholder: {
    fontSize: 24,
    fontWeight: '700',
  },
})
